import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-monitoring',
  imports: [CommonModule, RouterLink],
  templateUrl: './monitoring.html',
  styleUrl: './monitoring.css'
})
export class Monitoring {
  features = [
    {
      title: 'Metrics & Dashboards',
      description: 'Real-time metrics collection with Prometheus, Grafana, and CloudWatch for complete visibility.',
      icon: 'metrics'
    },
    {
      title: 'Centralized Logging',
      description: 'Aggregate logs from all sources with ELK Stack, Splunk, or CloudWatch Logs for easy troubleshooting.',
      icon: 'logging'
    },
    {
      title: 'Distributed Tracing',
      description: 'End-to-end request tracing with Jaeger, Zipkin, or AWS X-Ray for microservices debugging.',
      icon: 'tracing'
    },
    {
      title: 'Intelligent Alerting',
      description: 'Smart alerts with PagerDuty, Opsgenie, and custom webhooks to notify the right team at the right time.',
      icon: 'alerting'
    },
    {
      title: 'Application Performance Monitoring',
      description: 'APM with New Relic, Datadog, or Dynatrace for deep application insights and performance optimization.',
      icon: 'apm'
    },
    {
      title: 'Synthetic Monitoring',
      description: 'Proactive monitoring with synthetic checks to detect issues before users do.',
      icon: 'synthetic'
    }
  ];

  process = [
    { step: 1, title: 'Observability Assessment', description: 'Evaluate current monitoring gaps and define key metrics and SLOs.' },
    { step: 2, title: 'Tool Selection & Setup', description: 'Choose and configure the right observability stack for your needs.' },
    { step: 3, title: 'Instrumentation', description: 'Instrument applications and infrastructure for comprehensive data collection.' },
    { step: 4, title: 'Dashboards & Alerts', description: 'Create actionable dashboards and intelligent alerting strategies.' }
  ];

  caseStudy = {
    client: 'StreamTech Media',
    industry: 'Media & Entertainment',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=500&fit=crop',
    challenge: 'StreamTech experienced frequent outages that went undetected until customers complained. Their MTTR was over 4 hours, and they had no visibility into microservices performance or user experience.',
    solution: 'We implemented comprehensive observability with Prometheus, Grafana, ELK Stack, and distributed tracing. Custom dashboards and intelligent alerts enabled proactive issue detection.',
    results: [
      { metric: '87%', description: 'Reduction in MTTR' },
      { metric: '95%', description: 'Issues Detected Proactively' },
      { metric: '10min', description: 'Average Incident Detection Time' },
      { metric: '99.95%', description: 'Service Uptime Achieved' }
    ]
  };

  testimonial = {
    quote: 'The observability platform HoneyKode built changed everything. We now detect issues in minutes instead of hours, and often fix them before customers notice. Our MTTR dropped from 4 hours to 30 minutes. The visibility into our microservices is incredible.',
    author: 'Alex Thompson',
    role: 'VP of Operations',
    company: 'StreamTech Media',
    image: 'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=100&h=100&fit=crop'
  };

  tools = [
    { name: 'Prometheus', category: 'Metrics' },
    { name: 'Grafana', category: 'Visualization' },
    { name: 'ELK Stack', category: 'Logging' },
    { name: 'Datadog', category: 'APM' },
    { name: 'New Relic', category: 'APM' },
    { name: 'Jaeger', category: 'Tracing' },
    { name: 'PagerDuty', category: 'Incident Management' },
    { name: 'AWS CloudWatch', category: 'Cloud Monitoring' }
  ];
}
